<template>
  <div class="privacy-page">
    <div class="privacy-page__backdrop" aria-hidden="true"></div>
    <div class="privacy-page__inner">
      <header class="privacy-page__header">
        <button type="button" class="privacy-page__back" @click="goBack">
          <i class="fas fa-arrow-left"></i>
          返回
        </button>
        <h1 class="privacy-page__title">idoing 会员服务协议</h1>
        <p class="privacy-page__meta">
          <span>更新日期：2026 年 05 月 22 日</span>
          <span class="privacy-page__meta-sep">·</span>
          <span>生效日期：2026 年 05 月 22 日</span>
        </p>
      </header>

      <article class="privacy-doc">
        <p class="privacy-doc__lead">欢迎您使用 idoing 会员服务！</p>
        <p>
          《idoing 会员服务协议》（以下亦称「本协议」）由您（以下亦称「会员」或「VIP 会员」）与 idoing
          产品运营方及其关联方（以下简称「我们」或「idoing」）进行缔结，对双方具有同等法律效力。idoing
          建议您仔细阅读本协议的全部内容，尤其是以加粗形式展示的、与您的权益（可能）存在重大关系的条款（包括相关约定
          idoing 责任、您享有的权利、争议解决方式及司法管辖等条款），请您留意重点阅读。若您认为本协议中的加粗条款可能会导致您的部分或全部权利或利益受损，请您务必再次仔细阅读，在确保您已经理解、接受了加粗条款的前提下，继续使用
          idoing 会员服务。
        </p>
        <p>
          如果您不同意本协议的任一或全部条款内容，请不要以确认形式（包括但不限于支付行为/接受赠与、或完成了成为会员的全部程序而在此过程中未向
          idoing 提出关于本协议的任何异议）进行下一步操作或使用 idoing 会员服务。当您以确认形式进行下一步操作或使用 idoing
          会员服务时，即表示您与 idoing 已达成协议关系，您自愿接受本协议并遵守本协议项下的全部约定。
        </p>
        <p>
          idoing 有权变更本协议内容，一旦本协议内容发生变更的，idoing 将在相应页面、站内信或以其他合理方式进行通知，请您仔细阅读。如果您不同意变更的内容的，您可以选择停止使用
          VIP 会员服务。如您继续使用 VIP 会员服务的，则视为您已经同意变更的全部内容。更新后的协议自文首更新之日起生效。
        </p>
        <p>若您是未成年人，请您在监护人监护、指导下阅读并决定是否同意本协议。</p>
        <p>
          如您对本协议内容有任何疑问、意见或建议，您可通过发送邮件至
          <a :href="contactMailto">{{ contactEmail }}</a> 与我们联系。
        </p>

        <nav class="privacy-doc__toc">
          <p class="privacy-doc__toc-title">本协议目录：</p>
          <ol>
            <li><a href="#section-1">一、服务说明</a></li>
            <li><a href="#section-2">二、使用服务</a></li>
            <li><a href="#section-3">三、会员权益及额外付费相关</a></li>
            <li><a href="#section-4">四、收费及退订</a></li>
            <li><a href="#section-5">五、用户规范</a></li>
            <li><a href="#section-6">六、个人信息保护</a></li>
            <li><a href="#section-7">七、知识产权</a></li>
            <li><a href="#section-8">八、第三方服务</a></li>
            <li><a href="#section-9">九、免责声明</a></li>
            <li><a href="#section-10">十、服务变更、终止或中断</a></li>
            <li><a href="#section-11">十一、其他</a></li>
          </ol>
        </nav>

        <section id="section-1" class="privacy-doc__section">
          <h2>一、服务说明</h2>
          <p>
            1.1【idoing VIP 会员】是指完成了成为会员的所有程序，且在遵守本协议的前提下，在会员时长有效期内享受 idoing
            提供的 VIP 会员服务的自然人。
          </p>
          <p>
            1.2 idoing VIP 会员有多种会员类型可供您选择，目前包括体验版、基础版、专业版等，具体以 idoing
            会员购买页面展示为准。
          </p>
          <p>
            1.3【idoing VIP 会员服务】是由 idoing 向您提供的专享的会员权益，权益内容说明请您查看本协议第三节，本协议未明确的权益内容以
            idoing 会员权益介绍页面的描述为准。同时，idoing 在此善意提醒您，本协议中还有需要进行额外付费的服务，包括但不限于本协议第三节第
            3.2 条。
          </p>
          <p>
            1.4【idoing 会员服务协议】是
            <router-link to="/terms">《idoing 用户协议》</router-link>、
            <router-link to="/privacy">《idoing 隐私保护政策》</router-link>
            的补充协议，是其不可分割的一部分，与其具有同等法律效力；本协议如与前述协议发生冲突的，以本协议为准。
          </p>
          <p>
            1.5【idoing VIP 会员服务规则】是 idoing 已经或未来不时发布的与 VIP 会员服务相关的协议、公告、页面说明、通知、FAQ
            等内容，与本协议具有同等法律效力。
          </p>
        </section>

        <section id="section-2" class="privacy-doc__section">
          <h2>二、使用服务</h2>
          <h3>2.1 服务获取</h3>
          <p>
            2.1.1 idoing VIP 会员服务为收费服务，您可以通过支付相应的服务费用购买；同时，您亦可以通过营销活动、接受礼品卡等 idoing
            认可的途径获取服务。
          </p>
          <p>2.1.2 您在获取 idoing VIP 会员服务时，应当遵守法律法规、本协议约定，不侵犯第三方或 idoing 的合法权益。您不得自行（或协助他人）通过以下方式获取 VIP 会员服务：</p>
          <ol>
            <li>以商业性或其他非个人使用等目的；</li>
            <li>使用虚假信息、冒用他人信息等方式注册 idoing 账号；</li>
            <li>通过机器人软件、蜘蛛软件、爬虫软件等任何自动程序、脚本、软件等方式；</li>
            <li>未经 idoing 允许通过借用、租用、售卖、分享、转让 VIP 会员服务的方式；</li>
            <li>通过不正当手段或以违反诚实信用原则的方式（如利用规则漏洞、利用系统漏洞、滥用会员身份、黑色产业、投机等）；</li>
            <li>通过利用或破坏 idoing VIP 会员服务规则的方式。</li>
          </ol>
          <p>
            idoing 在此声明：任何未经 idoing 明示授权而售卖、租借或以类似方式转让 idoing VIP
            会员资格的行为属于侵犯 idoing 权益、扰乱 idoing 经营秩序的行为，idoing 有权依法追究其法律责任。
          </p>
          <h3>2.2 服务使用的基本原则</h3>
          <p>
            2.2.1 您在使用 idoing VIP 会员服务的过程中，应遵守法律法规及其他规范性文件，应遵守公共秩序，尊重社会公德，不得危害网络安全，不得利用网络从事危害国家安全、荣誉和利益，煽动颠覆国家政权、推翻社会主义制度，煽动分裂国家、破坏国家统一，宣扬恐怖主义、极端主义，宣扬民族仇恨、民族歧视，传播暴力、淫秽色情信息，编造、传播虚假信息扰乱经济秩序和社会秩序，以及侵害他人名誉、隐私、知识产权和其他合法权益等活动。如您存在上述行为的，idoing
            有权终止向您提供 idoing VIP 会员服务。
          </p>
          <p>
            2.2.2 除双方另有约定外，idoing 授予您对 idoing VIP 会员服务一项个人的、非独家的、非商业用途的、可撤销的、有期限的使用许可，即您仅可出于个人、非商业的目的使用
            VIP 会员服务。
          </p>
          <p>
            2.2.3 您理解并同意，您不得将享有账号以任何方式提供给他人使用，包括但不限于不得以转让、出租、借用、分享、出售等方式提供给他人作包括但不限于直播、录制、观看、上传、参加活动等使用。否则，因此产生的法律后果及责任均由您自行承担。同时因上述行为导致账号遗失、泄露、被篡改、被盗等损失的，或因多终端登录、异地登录等情况触发
            idoing 安全风控导致账号异常、账号被封的损失的，亦应当由您自行承担，且 idoing 有权根据您的违约情况决定是否中止或终止为您提供服务。
          </p>
        </section>

        <section id="section-3" class="privacy-doc__section">
          <h2>三、会员权益及额外付费相关</h2>
          <h3>3.1 VIP 会员权益</h3>
          <p>
            VIP 会员权益包括但不限于积分额度、模型调用权限、生成速度优先、专属功能等，具体以 idoing
            会员购买页面及权益介绍页面的描述为准。
          </p>
          <h3>3.2 额外付费</h3>
          <p>
            除 VIP 会员服务外，idoing 部分功能或服务可能需要您另行付费，包括但不限于超出会员额度后的积分充值、特定模型或高清视频生成等。请您在购买前仔细确认相关费用说明。
          </p>
          <h3>3.3 虚拟产品</h3>
          <p>
            3.3.1 您在使用 VIP 会员服务过程中可能取得/获赠由我们提供的各种算力、积分、卡券、优惠券、代金券、福利券、成长值等虚拟产品。前述虚拟产品仅能用于
            idoing 官方渠道公布的指定用途，且有使用期限、方式等限制，不能退货、兑换现金或转让、买卖、置换、抵押等，在使用后亦不会恢复，具体使用规则请以虚拟产品的服务页面展示或说明为准。
          </p>
          <p>
            3.3.2 同时，请您知悉，idoing 有权根据法律法规及监管政策要求、产品运营需要等原因对虚拟产品（包括但不限于算力、积分等）予以定价，并根据自身产品运营需要进行变更或调整，包括但不限于虚拟产品形式、类别、取得/获赠以及使用方式、范围、规则等，并以合理方式进行公告或通知，我们提醒您在取得/获赠或使用虚拟产品时注意查看。
          </p>
          <h3>3.4 活动参与</h3>
          <p>
            在 VIP 会员服务期限内，您有权选择参加由 idoing 组织的 VIP 活动并享有由 idoing 提供的各项优惠。具体活动及优惠的内容及规则以
            idoing 实际提供为准。
          </p>
          <h3>3.5 优惠政策</h3>
          <p>
            idoing 可能会根据实际运营情况对不同阶段已经购买且持续有效的 VIP 会员服务给予延期、权益升级等方面的优惠，具体优惠政策以 idoing
            在相关服务页面通知的内容为准。
          </p>
          <h3>3.6 使用规范</h3>
          <p>您在获取、使用 idoing VIP 会员服务（包括参与活动）时，应遵循 idoing 官方渠道公布的流程、平台规范等：</p>
          <p>
            3.6.1 不得通过未经 idoing 授权或公布的途径、方式、渠道非法获取 idoing VIP 会员服务（包括但不限于部分或全部会员权益、VIP
            会员账号）及/或参与活动获取福利（包括但不限于会员权益、虚拟产品、实体商品、会员服务兑换码，本条下同）；
          </p>
          <p>
            3.6.2 不得通过不正当手段或以违反诚实信用原则的方式（如利用规则漏洞、利用系统漏洞、滥用会员身份、黑色产业、投机等违背 idoing
            提供服务/举办活动初衷的方式）参与活动或者获取福利。
          </p>
          <p>
            3.6.3 如您存在违法、不当开通、使用任一或多项付费服务的情形，我们有权取消/作废您已购买的相应付费服务及对应权益，且将不会退还您已支付的对应服务费，您应对您违法、不当开通、使用任一或多项付费服务的行为及法律后果负责，若因此给我们造成损失的，我们有权向您追偿，且我们有权视情况采取本协议相关处理措施，并要求您退还您通过出售、转让、许可等其他方式取得的收益或非法获利（如有）。
          </p>
          <h3>3.7 服务期限</h3>
          <p>
            3.7.1 您的 VIP 会员服务的服务期限以您自行选择并支付相应会员费用对应的服务期限为准，自您成为 VIP
            会员之时起算，您可以通过登录 idoing VIP 会员相关页面免费查询。当会员服务期限到期后，idoing 将停止继续向您提供 VIP
            会员服务。但如您开通自动续费服务且您在服务期限到期前续费成功的，会员服务期限将在原服务期限的基础上顺延。自动续费的 VIP
            会员服务在当前周期内的服务有效期到期前，您可以单方面停止自动续费，idoing 亦可以根据运营策略需要而单方面停止继续向您自动续费服务，VIP
            会员服务期限自当前服务周期届满之日起终止。
          </p>
          <p>
            3.7.2 请您理解，因互联网服务的特殊性，VIP 会员服务期限中包含 idoing 解决故障、服务器维修、调整、升级等或因第三方侵权处理所需用的合理时间，但
            idoing 会尽可能将影响降至最低。
          </p>
        </section>

        <section id="section-4" class="privacy-doc__section">
          <h2>四、收费及退订</h2>
          <h3>4.1 收费方式</h3>
          <p>
            idoing VIP 会员服务为收费服务，您可通过 idoing 实际支持的付费方式完成 VIP 会员费用的支付，如第三方支付等。请您注意，若您使用您的会员账号绑定的通信账户进行支付，此付费方式为代收费运营商托收的付款方式，您通过此种付费方式付费可能存在一定的商业风险（如不法分子利用您账户或银行卡等有价卡等进行违法活动），该等风险可能会给您造成相应的经济损失，您应自行承担全部损失。
          </p>
          <h3>4.2 费用退还</h3>
          <p>
            VIP 会员服务系网络商品和虚拟商品，会员费用是您所购买的会员服务所对应的网络商品价格，而非预付款或者存款、定金、储蓄卡等性质，VIP
            会员服务一经开通后不可退款（如因 VIP 会员服务存在重大瑕疵导致您完全无法使用等 idoing 违约情形、本协议另有约定、法律法规要求必须退款的或 idoing
            同意退款等除外）。
          </p>
          <p>
            idoing 在此特别提醒您，您在购买 VIP 会员服务（包括自动续费服务）之前应仔细核对账号信息、购买的服务内容、价格、服务期限等信息。
          </p>
          <h3>4.3 收费标准、方式的变更</h3>
          <p>
            4.3.1 VIP 会员服务（包括自动续费）、收费标准由 idoing 根据公司的运营成本、运营策略等综合考虑后独立决定（调整包括但不限于促销、涨价等），并在相关的产品服务宣传及支付页面向您展示。若您在购买和续费时，相关收费方式发生变化的，以
            idoing 实际支持的收费方式为准；相关服务的价格发生了调整的，应以 idoing 平台上公示的现时有效的价格为准（但 idoing 与您另有约定的情形除外）。
          </p>
          <p>4.3.2 VIP 会员变更及叠加购买规则</p>
          <ol>
            <li>为提升用户体验，在部分场景下，我们支持会员用户在现有套餐基础上购买其他会员套餐，平台支持会员套餐类型、支付规则以相关会员购买页面展示为准。</li>
            <li>
              如您已是 VIP 会员，则在成功购买了另一会员套餐后，可在「订阅管理」-「订阅计划管理」页面选择是否立即生效新购买的会员套餐。如您不选择立即生效，则在您的旧会员套餐到期后（连续包月类套餐需在取消续费且到期后），新套餐会自动生效。如您选择立即生效，则您的新会员套餐将立即生效，请注意旧会员套餐将继续保持权益到有效期截止。
            </li>
          </ol>
          <h3>4.4 自动续费</h3>
          <p>
            自动续费服务是指在会员已购买 VIP 会员服务的前提下，出于会员对于自动续费的需求，避免会员因疏忽或其他原因导致未能及时续费而推出的服务。如会员选择开通自动续费服务的，即会员授权
            idoing 可在会员自动续费期限到期前 24 小时和到期后，委托支付渠道（如支付宝、微信等）代扣下一个计费周期的费用，部分由运营商或支付渠道根据实际情况自行决定扣费周期的以实际扣费时间为准，如手机话费渠道、iOS
            渠道等，扣款成功的，则为您自动延长对应的会员服务期限。
          </p>
        </section>

        <section id="section-5" class="privacy-doc__section">
          <h2>五、用户规范</h2>
          <h3>5.1 用户禁止行为</h3>
          <p>
            您在使用本产品/服务的过程中，应遵守相关法律法规、本协议、规则、规范等，不得从事包括但不限于以下任何行为，也不得为以下任何行为提供便利：
          </p>
          <p>5.1.1 法律法规禁止的行为</p>
          <p>您在使用本服务时须遵守法律法规，不得制作、复制、发布、传播含有下列内容的信息或从事相关行为，也不得为制作、复制、发布、传播含有下列内容的信息或从事相关行为提供便利：</p>
          <ol>
            <li>反对宪法所确定的基本原则的；</li>
            <li>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
            <li>损害国家荣誉和利益的；</li>
            <li>煽动民族仇恨、民族歧视，破坏民族团结的；</li>
            <li>破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
            <li>散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
            <li>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
            <li>侮辱或者诽谤他人，侵害他人合法权益的；</li>
            <li>违反法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的「七条底线」要求的；</li>
            <li>法律法规、本协议或使用本产品的其他规则等禁止的其他行为。</li>
          </ol>
          <p>5.1.2 产品使用</p>
          <p>除非法律法规允许或我们书面许可，您不得从事下列行为：</p>
          <ol>
            <li>删除本产品及其副本上关于著作权的信息；</li>
            <li>对本产品进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本产品的源代码；</li>
            <li>对我们拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</li>
            <li>对本产品或者本产品运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本产品运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非我们经授权的第三方工具/服务接入本产品和相关系统；</li>
            <li>通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</li>
            <li>通过非我们开发、授权的第三方软件、插件、外挂、系统，登录或使用本产品和/或本服务，或制作、发布、传播上述工具；</li>
            <li>自行、授权他人或利用第三方软件对本产品和/或本服务及其组件、模块、数据等进行干扰；</li>
            <li>其他可能影响、干扰本产品和/或本服务正常运行的行为。</li>
          </ol>
          <p>5.1.3 数据获取使用</p>
          <p>为了保护数据安全，您不得从事包括但不限于以下行为，也不得为其提供便利：</p>
          <ol>
            <li>未经其他用户明确同意，或在未向其他用户如实披露数据用途、使用范围等相关信息的情形下收集、复制、存储、使用或传输其他用户数据，侵害其他用户合法权益；</li>
            <li>将其他用户的账号、昵称等个人信息用于任何未经用户及我们授权的用途；</li>
            <li>企图进行反射查找、跟踪、关联、挖掘、获取用户账号、手机号和出生日期等个人信息；</li>
            <li>通过各种程序、软件等抓取任何用户的信息或与本产品和/或本服务相关的任何信息、数据；</li>
            <li>未经我们授权使用任何第三方软件、插件、外挂、系统等查看、获取本产品和/或本服务中所包含的我们、我们的合作伙伴或用户的任何相关信息、数据等内容；</li>
            <li>其他危害数据安全的行为。</li>
          </ol>
          <h3>5.2 法律责任</h3>
          <p>
            5.2.1 您理解并同意：若您违反法律法规、本协议和 idoing 平台公布的任何规则，idoing 有权随时单方根据相应情形采取以下一项或多项措施（具体措施以及采取措施的时间长短由我们根据您的违法、违约情节相应情况确定）：
          </p>
          <ol>
            <li>对您进行警告；</li>
            <li>删除违法违规信息；</li>
            <li>主动执行关闭相关交易订单；</li>
            <li>限制您使用本产品和/或本服务部分或全部功能；</li>
            <li>中止、终止您对相应服务账号的使用（简称「封号」）；</li>
            <li>采取其他合理、合法的措施；</li>
            <li>依法移交有关行政管理机关给予行政处罚，或者依法向有关机关报案追究刑事责任。</li>
          </ol>
          <p>
            5.2.2 如果您违反法律法规、本协议和 idoing 规则，我们对您或您使用的本产品和/或本服务采取任何行为或措施后，导致您暂时或永久无法使用服务账号，您应自行承担相应后果（包括但不限于通信中断、用户资料及相关数据的清空或无法使用等）。由此造成您损失的，您应自行承担。
          </p>
          <p>5.2.3 您导致任何第三方损害的，您应当独立承担责任；我们因此遭受损失的，您也应当一并赔偿。</p>
          <h3>5.3 对自己行为负责</h3>
          <p>
            您充分了解并同意，您必须为自己使用本产品和/或本服务的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对使用本产品和/或本服务时接触到的内容自行加以判断，包括因对内容的正确性、完整性或实用性的依赖而产生的风险，并承担由此引起的相应风险。我们在法律允许的范围内不对您因前述风险而导致的任何损失或损害承担责任。
          </p>
        </section>

        <section id="section-6" class="privacy-doc__section">
          <h2>六、个人信息保护</h2>
          <p>
            6.1 保护用户个人信息是我们的一项基本原则，我们将按照本协议及
            <router-link to="/privacy">《idoing 隐私保护政策》</router-link>
            的约定收集、使用、储存和分享您的个人信息。本协议对个人信息保护相关内容未作明确规定的，均应以《idoing 隐私保护政策》的内容为准。
          </p>
          <p>6.2 我们不会将您的个人信息转移或披露给任何第三方，除非：</p>
          <ol>
            <li>相关法律法规或司法机关、行政机关要求；</li>
            <li>为完成合并、分立、收购或资产转让而转移；或为提供您要求的服务所必需；</li>
            <li>依据《idoing 隐私保护政策》或其他相关协议规则可以转移或披露给任何第三方的情形。</li>
          </ol>
          <p>
            6.3 为了更好地向您提供本服务，在获得您的明确同意后，我们可对您服务账号中的昵称、头像以及在本产品中的相关操作信息（以下称「该等信息」）进行使用，并可在本产品中向您本人或其他用户展示该等信息。
          </p>
          <p>
            6.4 您在使用本服务某一特定功能时，我们在获得您明确同意的前提下可以使用您终端设备的相关权限、接口及相关信息等以实现相应的功能。您可以选择不向我们提供您的相关权限、接口、信息，或者根据产品设置取消我们使用相关权限、接口或收集某些信息的权利，但因此可能会导致相关服务功能无法实现。
          </p>
          <p>
            6.5 您应对通过本产品和/或本服务了解、接收或可接触到的包括但不限于其他用户在内的任何人的个人信息予以充分尊重，您不应以搜集、复制、存储、传播或以其他任何方式使用其他用户的个人信息，否则，由此产生的后果由您自行承担。
          </p>
        </section>

        <section id="section-7" class="privacy-doc__section">
          <h2>七、知识产权</h2>
          <h3>7.1 idoing 知识产权</h3>
          <p>
            我们是本产品的知识产权权利人。本产品的著作权、商标权、专利权、商业秘密等知识产权，以及与本产品相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受法律法规和相应的国际条约保护，我们依法享有上述相关知识产权，但相关权利人依照法律规定应享有的权利除外。
          </p>
          <h3>7.2 生成内容的商用许可</h3>
          <p>
            7.2.1 在您购买了 idoing 会员的情况下，使用 idoing 平台提供的 AI 模型生成的图片、视频等内容是否可商业化使用，以 idoing
            会员权益介绍页面及服务详情页的说明为准。
          </p>
          <p>7.2.2 非会员情况下，使用 idoing 平台 AI 功能生成的内容，其商用范围以平台相关页面说明为准，未经明确授权不得用于商业用途。</p>
          <p>
            7.2.3 使用第三方或开源模型时，需要您遵照相应模型详情页的作者声明为准，判断生成结果是否可以商用。
          </p>
          <p>7.3 您承诺对您通过本产品所上传的内容（包括但不限于文字、图片、模型等）拥有完整著作权或已获得合法授权，未侵犯任何第三方之合法权益。</p>
          <p>
            7.4 如您发现本产品及相关网站内的用户发布的内容存在任何侵犯您合法权利的情况，请立即通过官方邮箱（
            <a :href="contactMailto">{{ contactEmail }}</a>
            ）通知我们，提供您有关权利的初步证据，我们会根据法律法规要求及时处理您的投诉。
          </p>
        </section>

        <section id="section-8" class="privacy-doc__section">
          <h2>八、第三方服务</h2>
          <p>8.1 本产品可能会使用第三方软件或技术（包括本产品可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。</p>
          <p>
            8.2 本产品如果使用了第三方的软件或技术，我们将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本产品安装包特定文件夹中打包等形式进行展示，它们可能会以「软件使用许可协议」「授权协议」「开源代码许可证」或其他形式来表达。
          </p>
          <p>
            8.3 前述相关协议或其他文件均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、罚款或采取其他制裁措施，并要求我们给予协助，您应当自行承担法律责任。
          </p>
        </section>

        <section id="section-9" class="privacy-doc__section">
          <h2>九、免责声明</h2>
          <p>
            9.1 我们将努力保障您的合法权益。请您理解，在您使用本产品各项服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件。出现下列任一情况时，我们将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失，我们在法律允许的范围内免责：
          </p>
          <ol>
            <li>在与本服务相关的系统停机维护或升级期间；</li>
            <li>因自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、法律法规政策变化和政府行为等不可抗力原因；</li>
            <li>您操作不当或通过非我们授权或认可的方式使用本服务；</li>
            <li>受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</li>
            <li>电脑软件、系统、硬件和通信线路出现故障，程序版本过时、设备的老化和/或其兼容性问题，第三方服务瑕疵等原因；</li>
            <li>其他无法控制或合理预见的情形。</li>
          </ol>
          <p>
            9.2 您理解并同意，我们仅向您提供 AI 内容生成等相关的人工智能技术服务及其他辅助服务。除法律法规另有明确规定或本协议另有约定外，我们不成为您与第三方之间任何交易或业务的参与方，不对所涉包括文字、图片、视频在内的内容及/或第三方服务的质量、安全性及其合法性、真实性、准确性作出任何明示或暗示的担保。
          </p>
          <p>9.3 我们将会尽其商业上的合理努力保障您在本服务中的数据存储安全，但是，我们并不能就此提供完全保证，包括但不限于以下情形：</p>
          <ol>
            <li>非我们原因造成的您在本产品和/或本服务中相关数据的删除或储存失败负责；</li>
            <li>您应自行备份存储在本产品和/或本服务中的数据、信息或与本产品和/或本服务相关的数据、信息，双方另有约定的按相应约定执行；</li>
            <li>如果您停止使用本产品和/或本服务，或因您违反法律法规或本协议而被取消或终止使用本服务，我们有权从服务器上永久地删除您的数据。您的服务停止、终止或取消后，我们没有义务向您返还任何数据。</li>
          </ol>
          <p>9.4 您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，我们不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：</p>
          <ol>
            <li>来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；</li>
            <li>遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；</li>
            <li>其他因网络信息或用户行为引起的风险。</li>
          </ol>
          <p>
            9.5 您注意勿在使用本产品和/或本服务中透露自己的各类财产账户、银行卡、信用卡、第三方支付账户及对应密码等重要资料，否则由此带来的任何损失由您自行承担。您亦不应将其他个人信息通过 idoing
            发表、上传或扩散。
          </p>
          <p>
            9.6 您理解并同意：为了向您提供有效的服务，本产品会利用您终端设备的处理器和带宽等资源。本产品使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。
          </p>
          <p>
            9.7 基于用户体验、本产品或相关服务的运营安全、规则要求及 idoing 健康发展等综合因素，我们有权选择提供服务的对象，决定功能设置，决定功能开放、数据接口和相关数据披露的对象和范围。针对违反法律法规或本协议、影响服务体验、存在安全隐患或违背运营原则等情形，我们有权视具体情况中止或终止提供相关服务。
          </p>
          <p>
            9.8 为便于向您提供服务，我们可能在软件中设置相应的外部链接或第三方 SDK，除法律另有明确规定外，我们不对外部链接或第三方 SDK 的准确性、有效性、安全性和完整性做出任何承诺或保证。同时，对于该等外部链接或第三方
            SDK 指向的不由我们实际控制的任何网页或客户端上的内容，您同意我们将不承担相关责任。
          </p>
          <p>
            9.9 本协议项下涉及的所有 idoing 用户发布的内容，由发布方保证对相关内容享有作为权利人完整、合法、有效的权利或已取得权利人的合法授权。如因用户发布的内容存在侵权、违法违规或其他可能产生严重负面舆情等情形，导致用户发布内容被屏蔽或账号被限制使用的，您同意我们无需承担相关责任。您可以通过官方邮箱（
            <a :href="contactMailto">{{ contactEmail }}</a>
            ）协调处理相关投诉。
          </p>
        </section>

        <section id="section-10" class="privacy-doc__section">
          <h2>十、服务变更、终止或中断</h2>
          <p>
            10.1【协议变更通知】我们有权在必要时修改本协议内容，并将通过合理的方式（包括但不限于公告、系统消息、站内信、手机短信、电子邮件等）及合理的期限提前通知您，该等通知于发送之日视为已送达您。您可以通过
            idoing 相关页面查阅最新版本的协议内容。
          </p>
          <p>
            10.2【变更协议生效】本协议变更生效后，如您继续使用 idoing，即视为您已接受修改后的协议。如您不接受修改后的协议，应当停止使用。
          </p>
          <p>
            10.3【协议终止】您注销您的 idoing 账号或 idoing 通知您终止为您提供服务（包括但不限于封禁账号、注销账号等）时，本协议将同时终止，我们将不再另行通知您终止本协议。
          </p>
        </section>

        <section id="section-11" class="privacy-doc__section">
          <h2>十一、其他</h2>
          <p>
            11.1 我们有权在必要时修改本协议条款。您可以在相关服务页面查阅最新版本的协议条款。本协议条款变更后，如果您继续使用我们提供的软件或服务，即视为您已接受变更后的协议。
          </p>
          <p>11.2 本协议签订地为 idoing 产品运营方所在地。</p>
          <p>11.3 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
          <p>
            11.4 若您和我们之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
          </p>
          <p>11.5 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
          <p>11.6 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
          <p>
            11.7 如您对本协议有任何意见或建议，您可向 idoing 官方（
            <a :href="contactMailto">{{ contactEmail }}</a>
            ）反馈，我们会给予您必要的帮助。
          </p>
          <p class="privacy-doc__end">（正文完）</p>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VipMembershipAgreement',
  data() {
    return {
      contactEmail: 'pluskeji@126.com'
    }
  },
  computed: {
    contactMailto() {
      return `mailto:${this.contactEmail}`
    }
  },
  mounted() {
    document.title = 'idoing 会员服务协议'
  },
  beforeDestroy() {
    document.title = 'idoing'
  },
  methods: {
    goBack() {
      if (window.history.length > 1) this.$router.go(-1)
      else this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.privacy-page {
  position: relative;
  height: 100vh;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  background: #0e1014;
  color: rgba(255, 255, 255, 0.82);
}
.privacy-page__backdrop {
  pointer-events: none;
  position: fixed;
  inset: 0;
  z-index: 0;
  background:
    radial-gradient(ellipse 120% 80% at 50% -20%, rgba(56, 100, 180, 0.16) 0%, transparent 55%),
    linear-gradient(180deg, #0e1014 0%, #161922 45%, #12141a 100%);
}
.privacy-page__inner {
  position: relative;
  z-index: 1;
  max-width: 860px;
  margin: 0 auto;
  padding: 32px 20px 64px;
}
.privacy-page__header {
  margin-bottom: 28px;
}
.privacy-page__back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding: 8px 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.privacy-page__back:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}
.privacy-page__title {
  margin: 0 0 10px;
  font-size: clamp(28px, 4vw, 36px);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #fff;
}
.privacy-page__meta {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.42);
}
.privacy-page__meta-sep {
  margin: 0 8px;
}
.privacy-doc {
  padding: 28px 24px 36px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.02);
  line-height: 1.85;
  font-size: 14px;
}
.privacy-doc__lead {
  margin-top: 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.92);
}
.privacy-doc__end {
  margin-top: 24px;
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
}
.privacy-doc p {
  margin: 0 0 14px;
}
.privacy-doc a {
  color: #7dd3fc;
  text-decoration: none;
}
.privacy-doc a:hover {
  text-decoration: underline;
}
.privacy-doc__toc {
  margin: 24px 0 28px;
  padding: 18px 20px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
}
.privacy-doc__toc-title {
  margin: 0 0 10px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
}
.privacy-doc__toc ol {
  margin: 0;
  padding-left: 20px;
}
.privacy-doc__toc li {
  margin: 6px 0;
}
.privacy-doc__section {
  margin-top: 32px;
  scroll-margin-top: 24px;
}
.privacy-doc__section h2 {
  margin: 0 0 14px;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}
.privacy-doc__section h3 {
  margin: 20px 0 10px;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
}
.privacy-doc ol,
.privacy-doc ul {
  margin: 0 0 14px;
  padding-left: 22px;
}
.privacy-doc li {
  margin: 8px 0;
}
@media (max-width: 640px) {
  .privacy-page__inner {
    padding: 20px 14px 48px;
  }
  .privacy-doc {
    padding: 20px 16px 28px;
  }
}
</style>
